import d3 from '@/utils/d3importer'

// Calculate CW or CCW for a given polygon
let isCW = (points)=>{
  if(points.length<3) return true
  // coger el "top left" vertice y sus dos vecions ABC
  // B=topleft, A = B-1 y C = A+1
  // det(O) = (xb-xa)(yc-ya) - (xc-xa)(yb-ya)
  // let det = (b[0]-a[0])*(c[1]-a[1]) - (c[0]-a[0])*(b[1]-a[1])
  // return det
  let B = points.reduce((res,p)=>{
    if(p[0]<res[0]) return p
    else return res
  },points[0])
  let i = points.indexOf(B)
  let A = i>0?points[i-1]:points[points.length-1]
  let C = i<points.length-1?points[i+1]:points[0]
  let det = (B[0]-A[0])*(C[1]-A[1]) - (C[0]-A[0])*(B[1]-A[1])
  // console.log("ABC",A,B,C)
  // console.log("DET",det)
  return det>0
}

let dist = (a,b)=>{
  return Math.sqrt((b[0]-a[0])*(b[0]-a[0])+(b[1]-a[1])*(b[1]-a[1]))
}
let samePoint = (a,b)=>{
  return dist(a,b)<40
}
export default function() {
  var dispatch = d3.dispatch("start", "brush", "end"),
    el = null,
    x = null,
    y = null,
    w = 0,
    h = 0,
    extent = [],
    // firstClick = true,
    // firstTime = true,
    isClosed = false,
    isCreating = false,
    isDragging = false,
    // origin = null,
    line = d3.line()
      .x(function(d) {
          return d[0];
      })
      .y(function(d) {
          return d[1];
      });
  var brush = function(g) {
    el = g;
    g.each(function() {
      var bg, e, fg, as, ov;
      g = d3.select(this)
        .style("pointer-events", "all")
        .on("contextmenu",()=>{
          d3.event.preventDefault(); 
          return false
        })
        // .on("mousedown.brush", function(){
        .on("mouseup.brush", function(){
          // console.log(d3.event.which===3)
          if(d3.event.which === 3){
            d3.event.preventDefault(); 
            d3.event.stopImmediatePropagation()
            d3.event.stopPropagation()
            if(isCreating) cancelAnchor()
            else resetExtent()
            return
          }
          if(isCreating && extent.length>2 && samePoint(d3.mouse(this),extent[extent.length-2])){
            cancelAnchor()
            return
          }
          if(isDragging) return
          isDragging = false
          if(isClosed){
            isClosed = false
            extent.splice(0, extent.length);
            addAnchor.call(this)
            isCreating = true
          }
          if(!isCreating){
            isCreating = true
            addAnchor.call(this)
            dispatch.call("start", this);
          } 
          
          addAnchor.call(this)
        })
      bg = g.selectAll(".background")
        .data([0]).enter()
        .append("rect")
        .attr("class", "background")
        .style("visibility", "hidden")
        .style("cursor", "crosshair");
      ov = g.selectAll(".hole-overlay")
        .data([extent]).enter()
        .append("path")
        .attr("class", "hole-overlay")
      fg = g.selectAll(".extent")
        .data([extent]).enter()
        .append("path")
        .attr("class", "extent")
        .style("cursor", "move");
      as = g.selectAll(".anchors")
        .data([null]).enter()
        .append('g')
        .attr('class','anchors')
      if (x) {
          e = scaleExtent(x.range());
          bg.attr("x", e[0]).attr("width", e[1] - e[0]);
      }
      if (y) {
          e = scaleExtent(y.range());
          bg.attr("y", e[0]).attr("height", e[1] - e[0]);
      }
    });
  }
  
  var addAnchor = function() {
    let _this = this;
    extent.push(d3.mouse(this));
    moveAnchor(_this)
    el.on("mousemove", function() {
      console.log("move addedAnchor")
      return moveAnchor(_this);
    })
  }
  var cancelAnchor = function (){
    isCreating = false
    isClosed = true
    extent.pop(); 
    closePath(); 
    el.on("mousemove",null)
    drawPath();
  }
  var resetExtent = function (){
    extent.splice(0, extent.length);
    drawPath()
    dispatch.call("brush", this);
    dispatch.call("end", this);
  }
  var closePath = function() {
    // var w;
    // isCreating = false
    // w = d3.select(window);
    // w.on("dblclick.brush", null).on("mousemove.brush", null).on("contextmenu", null);
    // if (extent.length === 2 && extent[0][0] === extent[1][0] && extent[0][1] === extent[1][1]) {
    if(extent.length<3){
      extent.splice(0, extent.length);
      dispatch.call("brush", this);
      drawPath()
    }
    d3.select(".extent").on("mousedown.brush", moveExtent);
    return dispatch.call("end", this);
};  
  var moveAnchor = function(target,i=extent.length-1) {
    var point;
    point = d3.mouse(target);
    extent.splice(i, 1, point);
    drawPath()
    drawAnchors()
    dispatch.call("brush", this);
    
  };
  var moveExtent = function() {
    var _this = this;
    d3.event.stopPropagation();
    d3.event.preventDefault();
    d3.select(window).on("mousemove", function() {
      isDragging = true
      return dragExtent(_this);
    }).on("mouseup.brush", function(){
      isDragging = false
      d3.select(window).on("mousemove",null).on("mouseup.brush",null)
    });
    origin = d3.mouse(this);

  };
  var dragExtent = function(target) {
    var checkBounds, fail, p, point, scaleX, scaleY, updateExtentPoint, _i, _j, _len, _len1;
    point = d3.mouse(target);
    scaleX = point[0] - origin[0];
    scaleY = point[1] - origin[1];
    fail = false;
    origin = point;
    updateExtentPoint = function(p) {
        p[0] += scaleX;
        p[1] += scaleY;
    };
    for (_i = 0, _len = extent.length; _i < _len; _i++) {
        p = extent[_i];
        updateExtentPoint(p);
    }
    checkBounds = function(p) {
        if (!withinBounds(p)) {
            fail = true;
        }
        return fail;
    };
    for (_j = 0, _len1 = extent.length; _j < _len1; _j++) {
        p = extent[_j];
        checkBounds(p);
    }
    // if (fail) {
    //     return;
    // }
    drawPath();
    return dispatch.call("brush", this, {
        mode: "move"
    });
  };
  var scaleExtent = function(domain) {
    var start, stop;
    start = domain[0];
    stop = domain[domain.length - 1];
    if (start < stop) {
        return [start, stop];
    } else {
        return [stop, start];
    }
  };
  var withinBounds = function(point) {
      var rangeX, rangeY, _x, _y;
      rangeX = scaleExtent(x.range());
      rangeY = scaleExtent(y.range());
      _x = Math.max(rangeX[0], Math.min(rangeX[1], point[0]));
      _y = Math.max(rangeY[0], Math.min(rangeY[1], point[1]));
      return point[0] === _x && point[1] === _y;
  };
  var drawAnchors = function (){
    // PARECE QE "wasdragged" no sirve....
    // conflictos "despues" con el on(click) en los anchors

    let anchors = el.select('.anchors').selectAll('.anchor').data(extent)
    anchors.exit().remove()
    let anchorsEnter = anchors.enter().append('g').attr('class','anchor')
      .on('mousedown',(d)=>{
        if(isCreating) return
        isDragging = true
        d3.event.stopPropagation()
        d3.event.stopImmediatePropagation()
        let w = d3.select(window);
        let idx = extent.findIndex((a)=>a===d)
        w.on("mousemove", function() {
          console.log("move exisitngAnchor")
          return moveAnchor(el.node(),idx);
        })
        w.on("mouseup", function () {
          d3.event.stopPropagation()
          d3.event.stopImmediatePropagation()
          w.on("mousemove",null).on("mouseup",null)
          isDragging = false
        })
      })
    anchorsEnter.append('circle')
      .attr('r',15)
      .attr('fill','transparent') //'rgba(0,0,0,0.1)')
      .style('cursor','pointer')
    anchorsEnter.append('circle')
      .attr('r',5)
      .style('pointer-events','none')
    anchors = anchors.merge(anchorsEnter)
    // anchors.attr('cx',(d)=>d[0]).attr('cy',(d)=>d[1])
    anchors.attr('transform',(d)=>`translate(${d[0]},${d[1]})`).attr('opacity',(d,i)=>{
      if(extent.length>2 && i===extent.length-1) {
        if(samePoint(extent[extent.length-2],d)) return 0
        else return 5
      }
      else return 5
    })
  }
  var drawPath = function() {
    drawAnchors()
    
    
    return el.each(function() {
      d3.select(this)
        .selectAll(".extent").attr("d", function(d) {
            return  line(d) + "Z" ;
        });
      
      d3.select(this)
        .selectAll(".hole-overlay").attr("d", function(d) {
          // let cw = isCW(extent)
          // console.log("cw is",cw)
          if(extent.length<3) return ''
          if(isCW(extent)) return  `M 0 0 v ${h} h ${w} v -${h} h -${w}` + line(d) + "Z" ;
          else return  `M 0 0 h ${w} v ${h} h -${w} v -${h}` + line(d) + "Z" ;
      });
    });
  };
  
  
  brush.isWithinExtent = function(x, y) {
    var i, j, len, p1, p2, ret, _i, _len;
    len = extent.length;
    j = len - 1;
    ret = false;
    for (i = _i = 0, _len = extent.length; _i < _len; i = ++_i) {
        p1 = extent[i];
        p2 = extent[j];
        if ((p1[1] > y) !== (p2[1] > y) && x < (p2[0] - p1[0]) * (y - p1[1]) / (p2[1] - p1[1]) + p1[0]) {
            ret = !ret;
        }
        j = i;
    }
    return ret;
  };
  brush.x = function(z) {
      if (!arguments.length) {
          return x;
      }
      x = z;
      w = x.range()[1]-x.range()[0]
      return brush;
  };
  brush.y = function(z) {
      if (!arguments.length) {
          return y;
      }
      y = z;
      h = y.range()[0]-y.range()[1]
      return brush;
  };
  brush.extent = function(z) {
      if (!arguments.length) {
          return extent;
      }
      extent = z;
      return brush;
  };
  brush.clear = function() {
      extent.splice(0, extent.length);
      return brush;
  };
  brush.empty = function() {
      return extent.length === 0;
  };

  brush.on = function(typename, callback) {
      dispatch.on(typename, callback);
      return brush;
  };

  return brush;
}
